import type { PropsWithChildren } from 'react'
import React from 'react'

import styles from './Layout.module.css'
import Navigation from '../Navigation/Navigation'
import Footer from '../Footer/Footer'

const Layout: React.FC<PropsWithChildren> = ({ children, ...rest }) => {
  return (
    <>
      <Navigation />
      <main className={styles.layout} {...rest}>
        <div className={styles.container}>{children}</div>
      </main>
      <Footer />
    </>
  )
}

export default Layout
